import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ServiceProvider } from '@/context/ServiceContext'
import { AuthProviderWrapper } from '@/context/AuthContext'
import { SarahUIProvider } from '@/context/SarahUIContext'
import { Layout } from '@/components/Layout'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { SarahPanel } from '@/components/sarah/SarahPanel'

import { LandingPage } from '@/pages/LandingPage'
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { EpisodeLibraryPage } from '@/pages/EpisodeLibraryPage'
import { EpisodeDetailsPage } from '@/pages/EpisodeDetailsPage'
import { EpisodePlayerPage } from '@/pages/EpisodePlayerPage'
import { QuizPage } from '@/pages/QuizPage'
import { QuizResultsPage } from '@/pages/QuizResultsPage'
import { CertificatePage } from '@/pages/CertificatePage'
import { ProfilePage } from '@/pages/ProfilePage'
import { OrgDashboardPage } from '@/pages/OrgDashboardPage'
import { LearnerManagementPage } from '@/pages/LearnerManagementPage'
import { LeaderboardPage } from '@/pages/LeaderboardPage'
import { MissionsPage } from '@/pages/MissionsPage'
import { StoryPlayerPage } from '@/pages/StoryPlayerPage'
import { EscapeRoomPage } from '@/pages/EscapeRoomPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { ORG_MANAGER_ROLES } from '@/domain/roles'

// Route map (Document 11 §Phase 1 / user journey, extended in P1):
// Landing -> Demo Login -> Dashboard -> Episode Library -> Episode Details
// -> Episode Player -> Quiz -> Results -> (Badges/XP inline) -> Certificate.
export default function App() {
  return (
    <ServiceProvider>
      <AuthProviderWrapper>
        <SarahUIProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/episodes"
                element={
                  <ProtectedRoute>
                    <EpisodeLibraryPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/episodes/:id"
                element={
                  <ProtectedRoute>
                    <EpisodeDetailsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/episodes/:id/watch"
                element={
                  <ProtectedRoute>
                    <EpisodePlayerPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/episodes/:id/quiz"
                element={
                  <ProtectedRoute>
                    <QuizPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/episodes/:id/quiz/results/:resultId"
                element={
                  <ProtectedRoute>
                    <QuizResultsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/certificates/:id"
                element={
                  <ProtectedRoute>
                    <CertificatePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/team"
                element={
                  <ProtectedRoute allowedRoles={ORG_MANAGER_ROLES}>
                    <OrgDashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/team/learners"
                element={
                  <ProtectedRoute allowedRoles={ORG_MANAGER_ROLES}>
                    <LearnerManagementPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leaderboard"
                element={
                  <ProtectedRoute>
                    <LeaderboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/missions"
                element={
                  <ProtectedRoute>
                    <MissionsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/stories/:id"
                element={
                  <ProtectedRoute>
                    <StoryPlayerPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/escape-rooms/:id"
                element={
                  <ProtectedRoute>
                    <EscapeRoomPage />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
          <SarahPanel />
        </BrowserRouter>
        </SarahUIProvider>
      </AuthProviderWrapper>
    </ServiceProvider>
  )
}
